import { render, staticRenderFns } from "./C-Skills.vue?vue&type=template&id=659921be&scoped=true&"
import script from "./C-Skills.vue?vue&type=script&lang=js&"
export * from "./C-Skills.vue?vue&type=script&lang=js&"
import style0 from "./C-Skills.vue?vue&type=style&index=0&id=659921be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659921be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
